import React, { useState, useEffect, useRef } from "react";
import { generateInternalBarcode } from "../../data/catalog";

const QuickProductForm = ({ onAddProduct, onCancel }) => {
  const barcodeInputRef = useRef(null);
  const [formData, setFormData] = useState({
    name: "",
    barcode: "",
    price_ttc: "",
  });

  useEffect(() => {
    // Auto-focus barcode so the cashier can immediately scan an item
    if (barcodeInputRef.current) {
      setTimeout(() => barcodeInputRef.current.focus(), 100);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleGenerateBarcode = () => {
    const newBarcode = generateInternalBarcode();
    setFormData((prev) => ({ ...prev, barcode: newBarcode }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.price_ttc) return;

    const barcode = formData.barcode || generateInternalBarcode();
    const productId = `custom-${Date.now()}`;
    const price = parseFloat(formData.price_ttc);
    
    onAddProduct({
      id: productId,
      title: formData.name,
      name: formData.name,
      price: price,
      barcode: barcode,
      sku: "", 
      quantity: 1, // Default to 1 on ticket
      stock: 0, // No stock tracked until completed
      isWeighted: false,
      saleType: "unit",
      category: "Inconnu",
      supplierId: "",
      isIncomplete: true, // Flags this product as needing completion later
      product: {
        id: productId,
        name: formData.name,
        price: price,
        type: "regular"
      }
    });
  };

  return (
    <div className="card shadow-sm border-0 h-100" style={{ backgroundColor: "#1f2937", color: "white" }}>
      <div className="card-header border-bottom-0 pb-0 bg-transparent pt-4 text-center">
        <h5 className="fw-bold text-warning"><i className="bi bi-lightning-charge-fill me-2"></i>CRÉATION EXPRESS</h5>
        <p className="small text-muted mb-0">Ajoutez le produit au ticket. Vous compléterez les détails plus tard.</p>
      </div>
      <div className="card-body d-flex flex-column justify-content-center px-4">
        <form onSubmit={handleSubmit} className="d-flex flex-column gap-4">
          
          <div>
            <label className="form-label small fw-bold text-light opacity-75">1. SCANNEZ LE CODE-BARRES</label>
            <div className="input-group input-group-lg">
              <input ref={barcodeInputRef} type="text" className="form-control bg-dark text-white border-secondary" name="barcode" value={formData.barcode} onChange={handleChange} placeholder="Scannez l'article..." />
              <button className="btn btn-secondary border-secondary fw-bold" type="button" onClick={handleGenerateBarcode} title="Générer un code interne">
                Générer
              </button>
            </div>
          </div>

          <div>
            <label className="form-label small fw-bold text-light opacity-75">2. PRIX DE VENTE (TTC) *</label>
            <div className="input-group input-group-lg">
              <input type="number" step="0.01" className="form-control bg-dark text-white border-secondary fw-bold text-end text-success fs-3" name="price_ttc" value={formData.price_ttc} onChange={handleChange} placeholder="0.00" required />
              <span className="input-group-text bg-dark text-white border-secondary fw-bold">€</span>
            </div>
          </div>

          <div>
            <label className="form-label small fw-bold text-light opacity-75">3. NOM DU PRODUIT *</label>
            <input type="text" className="form-control form-control-lg bg-dark text-white border-secondary" name="name" value={formData.name} onChange={handleChange} placeholder="Ex: Coca Cola 33cl" required />
          </div>

          <div className="d-flex gap-2 mt-2">
            <button type="submit" className="btn btn-lg fw-bold flex-grow-1" style={{ backgroundColor: "#f97316", color: "white" }}>
              AJOUTER AU TICKET
            </button>
            <button type="button" className="btn btn-lg btn-secondary fw-bold px-4" onClick={onCancel}>
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default QuickProductForm;

